import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import background from "../Images/bg.png";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    number: '',
    msg: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    toast.success('E-mail envoyé avec succès!', {
      position: 'top-right',
      autoClose: 5000, 
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  return (
    <main className="contact">
    <section className="row">
      <div className="image">
        <img src={background} alt="image_de_fond" />
      </div>
  
      <form onSubmit={handleSubmit}>
        <h3>Contactez-nous!</h3>
        <label htmlFor="name"  className="form-label">Nom :</label>
        <input
          type="text"
          placeholder="Entrez votre nom"
          name="name"
          id="name" 
          value={formData.name}
          onChange={handleChange}
          required
          maxLength="50"
          className="box"
        />
        <label htmlFor="email" className="form-label">Adresse E-mail :</label>
        <input
          type="email"
          placeholder="Entrez votre adresse e-mail"
          name="email"
          id="email"
          value={formData.email}
          onChange={handleChange}
          required
          maxLength="50"
          className="box"
        />
        <label htmlFor="number" className="form-label">Numéro de Téléphone :</label>
        <input
          type="number"
          placeholder="Entrez votre numéro de téléphone"
          name="number"
          id="number" 
          value={formData.number}
          onChange={handleChange}
          required
          maxLength="50"
          className="box"
        />
        <label htmlFor="msg" className="form-label">Message :</label>
        <textarea
          name="msg"
          id="msg"
          value={formData.msg}
          onChange={handleChange}
          className="box"
          placeholder="Entrez votre message"
          required
          maxLength="1000"
          cols="30"
          rows="10"
        ></textarea>
        <input type="submit" value="Envoyer le message" className="purple-btn" name="submit" />
      </form>
    </section>

      <section className="box-container">
        <article className="box">
          <FontAwesomeIcon icon={faPhone} />
          <h3>Numéro de Téléphone</h3>
          <NavLink to="tel:09111111">0911111111</NavLink>
        </article>

        <article className="box">
          <FontAwesomeIcon icon={faEnvelope} />
          <h3>Adresse E-mail</h3>
          <NavLink to="mailto:ukulearn@ukulearn.com">ukulearn@ukulearn.com</NavLink>
        </article>

        <article className="box">
          <FontAwesomeIcon icon={faMapMarkerAlt} />
          <h3>Adresse du Bureau</h3>
          <NavLink to="#">123 rue de la Musique, Paris 16e.</NavLink>
        </article>
      </section>
    </main>
  );
};

export default Contact;
